import { CSSProperties } from 'react';

export const fullWidthButtonStyle: CSSProperties = {
	width: '100%',
};
